import { Component } from "../extends";

export default () =>
	class Html extends Component() {
		events() {
			this.$EE.on("SiteHamburger:enable", () => this.open());
			this.$EE.on("SiteHamburger:disable", () => this.close());
		}

		open() {
			this.el.classList.add("has-scroll-disabled");
		}

		close() {
			this.el.classList.remove("has-scroll-disabled");
		}
	};
